import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';


@Injectable()
export class Step1Guard implements CanActivate {

  constructor(private _router: Router, private _storage: LocalStorageService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    const lead = this._storage.retrieve('lead') || '';

    if (lead) {
        return true;
    }

    this._router.navigate(['/local/registro/1/gracias']);

    return false;
  }
}
